import React from 'react'
import { styled } from '@mui/material/styles'
import { Stack, Typography } from '@mui/material'

import { APP_RELEASE_VERSION } from 'qap/constants'
import useAPIStatus from 'hooks/api/useAPIStatus'

type AppVersionStyles = {
  color?: string | null | undefined;
};

type AppVersionType = {
  label: string;
  description: string | null | undefined;
  show: boolean;
};

// @ts-expect-error - TS2339 - Property 'styles' does not exist on type 'StackOwnProps & CommonProps & Omit<Omit<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "ref"> & { ...; }, keyof CommonProps | keyof StackOwnProps> & MUIStyledCommonProps<...> & { ...; }'.
const StyledStack = styled(Stack)(({ theme, styles = {} }) => ({
  alignItems: 'flex-end',
  '& .MuiTypography-root': {
    color: styles.color || theme.palette.grey[600],
    fontSize: theme.typography.caption.fontSize,
  },
}))

const AppVersion = ({
  styles,
}: {
  styles?: AppVersionStyles;
}) => {
  const { apiVersion } = useAPIStatus()
  const APP_VERSIONS: Array<AppVersionType> = [
    { label: 'myQAP', description: APP_RELEASE_VERSION, show: Boolean(APP_RELEASE_VERSION) },
    { label: 'API', description: apiVersion, show: Boolean(apiVersion) },
  ]

  return (
// @ts-expect-error - TS2322 - Type '{ children: (false | Element)[]; styles: AppVersionStyles | undefined; }' is not assignable to type 'IntrinsicAttributes & StackOwnProps & CommonProps & Omit<Omit<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "ref"> & { ...; }, keyof CommonProps | keyof StackOwnProps> & MUIStyledCommonProps<...> & { ...; }'.
    <StyledStack styles={styles}>
      {APP_VERSIONS.map(
        ({ label, description, show }) =>
          show && (
            <Typography key={label}>
              {label} {description}
            </Typography>
          ),
      )}
    </StyledStack>
  )
}

export default AppVersion
